import { withRipple } from '../../hocs/withRipple/index.js';
import * as React from 'react';
import { BtnContent, BtnIcon, BtnText, Btn } from './styles.js';
import { ButtonColor } from './types.js';
import { SonntagIcon } from '../../SonntagIcon/SonntagIcon.js';

const ButtonWithRippleEffect = withRipple(Btn);
const renderIcon = (icon, iconPath) => {
    if (iconPath) {
        return React.createElement(SonntagIcon, { iconPath: iconPath, color: "currentColor" });
    }
    if (icon) {
        return icon;
    }
    return null;
};
/**
 * @deprecated Use DefaultButton instead
 */
const Button = ({ type = 'button', isDisabled = false, small = false, outlined = false, borderColor, color = ButtonColor.grey, fullWidth, icon, endIcon, iconPath, children, rippleColor, typography = 'SuperTinyHeadline', iconSize = '', href = '', ...rest }) => {
    const isButton = isDisabled || href === '';
    return (React.createElement(ButtonWithRippleEffect, { type: isButton ? type : undefined, transientDisabled: isDisabled, disabled: isButton ? isDisabled : undefined, href: isButton ? undefined : href, forwardedAs: isButton ? undefined : 'a', outlined: outlined, borderColor: borderColor, color: color, small: small, iconBtn: !!icon || !!iconPath, hasChildren: !!children, fullWidth: Boolean(children && fullWidth), rippleColor: rippleColor, ...rest },
        React.createElement(BtnContent, { typography: typography },
            (!!icon || !!iconPath) && (React.createElement(BtnIcon, { position: "start", hasMargin: !!children, iconSize: iconSize, small: small }, renderIcon(icon, iconPath))),
            !!children && React.createElement(BtnText, null, children),
            !!endIcon && (React.createElement(BtnIcon, { position: "end", hasMargin: !!children, iconSize: iconSize, small: small }, endIcon)))));
};

export { Button, ButtonColor };
